'use client';
import { motion } from 'framer-motion';
import { XYCHART_ENTER_DURATION_S, XYCHART_HOVER_TRANSITION_MS, } from './xychart-constants';
import type { XYChartSeriesLayout } from './xychart-types';
export interface XYChartBarHoverInput {
    seriesIndex: number;
    categoryIndex: number;
}
export interface XYChartBarsLayerProps {
    series: XYChartSeriesLayout[];
    safeId: string;
    horizontal: boolean;
    seriesOpacityFor: (seriesIndex: number) => number;
    onHoverBar: (input: XYChartBarHoverInput) => void;
}
function getBarDebugIdentity(input: {
    seriesLabel: string;
    value: number;
}): string {
    return `${input.seriesLabel}-value-${input.value}`;
}
export function XYChartBarsLayer({ series, safeId, horizontal, seriesOpacityFor, onHoverBar, }: XYChartBarsLayerProps) {
    return (
      <>
      {series.map((seriesLayout) => (<g key={`bars-${seriesLayout.seriesIndex}`} style={{
                opacity: seriesOpacityFor(seriesLayout.seriesIndex),
                transition: `opacity ${XYCHART_HOVER_TRANSITION_MS}ms ease-out`,
            }}>
          {seriesLayout.bars.map((bar) => !bar.path ? null : (<motion.path data-el="Cmarkdownxychart/BarsLayer/Entry" key={`bar-${seriesLayout.seriesIndex}-${bar.categoryIndex}`} d={bar.path} fill={`url(#${safeId}-bar-${seriesLayout.seriesIndex})`} initial={horizontal ? { scaleX: 0 } : { scaleY: 0 }} animate={horizontal ? { scaleX: 1 } : { scaleY: 1 }} transition={{
                    duration: XYCHART_ENTER_DURATION_S,
                    delay: bar.categoryIndex * 0.025,
                    ease: [0.22, 1, 0.36, 1],
                }} style={{
                    transformOrigin: `${bar.zeroX}px ${bar.zeroY}px`,
                }} onMouseEnter={() => {
                    onHoverBar({
                        seriesIndex: seriesLayout.seriesIndex,
                        categoryIndex: bar.categoryIndex,
                    });
                }}/>))}
        </g>))}
      </>
    );
}
